'use strict';
namespace Dashboard {

    angular
        .module('dashboard')
        .constant('dashboardEnabledConfig', 'DashboardBookingEnabled')
        .constant('dashboardDisabledReferenceUrl', '/manage-your-booking/options.aspx')
        .constant('dashboardDisabledUrl', '/account/bookings.aspx');

}
